import axios from 'axios'


const SingleChartDataLoadAPI = (model, stockCode) =>
    axios.get(`${process.env.REACT_APP_STOCK_DOMAIN}/fetch/${model}/${stockCode}`)


export default { SingleChartDataLoadAPI }
